module.exports = __webpack_public_path__ + "img/グループ 233.6dd82b36.png";